import React from "react";
// nodejs library that concatenates classes
// nodejs library to set properties for components
import PropTypes from "prop-types";
import { Box } from "@mui/material";
// @material-ui/core components
// @material-ui/icons

// core components
import cardFooterStyle from "../../assets/jss/components/cardFooterStyle.jsx";

function CardFooter({ ...props }) {
  const { sx, children, ...rest } = props;
  return (
    <Box
      component="div"
      className="CardFooter"
      sx={[cardFooterStyle.cardFooter, ...(Array.isArray(sx) ? sx : [sx])]}
      {...rest}
    >
      {children}
    </Box>
  );
}

CardFooter.propTypes = {
  sx: PropTypes.object,
};

export default CardFooter;
